export default { 
  addProfessionalProfile: ({ commit }, payload) => commit('ADD_PROFESSIONAL_PROFILE', payload),
}